import { nudgeBeta, nudgeGamma, nudgeProd } from '../config/cognitoAuthSettings';
import { DOMAIN, STAGES } from '../constants/urlConstants';

export const getEnvironmentStage = location => {
  const currentLocation = location && 'host' in location ? location : window.location;
  let stage = STAGES.BETA;
  const hostName = currentLocation?.host?.toString().toLowerCase();
  if (hostName?.startsWith(DOMAIN[STAGES.BETA])) {
    stage = STAGES.BETA;
  } else if (hostName?.startsWith(DOMAIN[STAGES.PROD])) {
    stage = STAGES.PROD;
  } else if (hostName?.startsWith(DOMAIN[STAGES.GAMMA])) {
    stage = STAGES.GAMMA;
  } else {
    stage = STAGES.BETA;
  }
  return stage;
};

export const getStageSpecificCognitoAuthSettings = stage => {
  let authData = {};
  if (stage === STAGES.UNKNOWN_STAGE) {
    return authData;
  }
  switch (stage) {
    case STAGES.BETA: {
      return nudgeBeta;
    }
    case STAGES.GAMMA: {
      return nudgeGamma;
    }
    case STAGES.PROD: {
      return nudgeProd;
    }
    default: {
      return nudgeBeta;
    }
  }
};
